module.exports = __webpack_public_path__ + "img/tarjeta-premium.eee7da67.webp";